const ColorBadgePlugin = {
    install(Vue) {
        /**
         * Obtiene el color hexadecimal correspondiente a un color predefinido.
         * Si el color ya es hexadecimal, lo devuelve tal cual.
         *
         * @param {string} color - Color en formato hexadecimal o nombre.
         * @returns {string} - Color en formato hexadecimal.
         * @author Brandon Torres
         */
        function getHexColor(color) {
            const colorMap = {
                success: "#4dbd74",
                danger: "#f86c6b",
                warning: "#ffc107",
                info: "#63c2de",
                light: "#f0f3f5",
                primary: "#20a8d8",
                secondary: "#c8ced3",
            };

            const hexColor = colorMap[color] || color;
            const isHex = /^#([0-9A-F]{3}){1,2}$/i.test(hexColor);
            return isHex ? hexColor : "#000000";
        }

        /**
         * Determina si el color de texto debe ser claro u oscuro según el color de fondo.
         *
         * @param {string} hexcolor - Color en formato hexadecimal.
         * @returns {string} - Color de texto ('black' o 'white').
         * @author Brandon Torres
         */
        Vue.prototype.$getContrastYIQ = function (hexcolor) {
            hexcolor = getHexColor(hexcolor);
            hexcolor = hexcolor.replace("#", "");
            const r = parseInt(hexcolor.substring(0, 2), 16);
            const g = parseInt(hexcolor.substring(2, 4), 16);
            const b = parseInt(hexcolor.substring(4, 6), 16);

            const brightness = r * 0.299 + g * 0.587 + b * 0.114;
            return brightness > 230 || (r > 200 && g > 200 && b < 150)
                ? "black"
                : "white";
        };

        /**
         * Genera un badge de color con el texto en color de contraste adecuado.
         *
         * @param {string} color - Color de fondo del badge en formato hexadecimal o nombre.
         * @param {string} message - Mensaje a mostrar en el badge.
         * @returns {string} - HTML del badge.
         * @author Brandon Torres
         */
        Vue.prototype.$colorBadge = function (color, message) {
            color = getHexColor(color);
            const textColor = this.$getContrastYIQ(color);
            return `<span class="badge-custom" style="background-color: ${color}; color: ${textColor};">${message}</span>`;
        };
    },
};

export default ColorBadgePlugin;
